/**
 * src/data/templates.js — danh mục mẫu tải về.
 *
 * TEMPLATES = mẫu sinh từ code (khai báo ngay dưới đây) + mẫu dạng tệp đã
 * xuất bản từ /admin/mau, được scripts/fetch-templates.mjs kéo về lúc build
 * (src/data/templatesRemote.js). Nhờ vậy mẫu tải lên cũng có trang tĩnh,
 * structured data và nằm trong sitemap sau lần deploy kế tiếp.
 *
 * ƯU TIÊN MẪU SINH TỪ CODE: sửa một công thức là mọi bản tải về sau đó đều
 * đúng. Chỉ dùng mẫu dạng tệp cho mẫu quá phức tạp để sinh bằng code. Mẫu
 * dạng tệp có đánh số phiên bản và giữ lịch sử (xem src/lib/templateModel.js).
 *
 * Mỗi mẫu có một trang riêng /mau/<slug> để Google xếp hạng theo từ khoá dạng
 * "mẫu excel …", và được nhúng trong bài Playbook tương ứng.
 */

import REMOTE_TEMPLATES from './templatesRemote.js';

const TEMPLATES_SINH = [
  {
    slug: 'mo-hinh-tai-chinh-saas',
    kind: 'sinh', nhom: 'mo-hinh-tai-chinh', nganh: ['saas'], nganhMoHinh: 'saas', giaiDoan: ['Pre-seed', 'Seed'], doSau: 'lite', nhanNgan: '12 tháng, 4 tab',
    title: 'Mẫu mô hình tài chính cho startup SaaS',
    tenFile: 'mo-hinh-tai-chinh-saas',
    excerpt: 'Mô hình 12 tháng theo khách mới, tỷ lệ rời đi và doanh thu bình quân mỗi khách; tự tính LTV, CAC payback, burn multiple và runway.',
    bienSo: ['Khách mới mỗi tháng và tốc độ tăng', 'Tỷ lệ khách rời đi (churn)', 'Doanh thu bình quân mỗi khách', 'Biên lợi nhuận gộp', 'Chi phí thu hút một khách (CAC)'],
    baiLienQuan: 'mo-hinh-tai-chinh-cho-startup-saas',
    congCu: [{ slug: 'kiem-tra-gia-dinh-kinh-te-don-vi', label: 'Kiểm tra kinh tế đơn vị' }, { slug: 'tinh-runway', label: 'Tính runway' }],
  },
  {
    slug: 'mo-hinh-tai-chinh-chuoi-fnb',
    kind: 'sinh', nhom: 'mo-hinh-tai-chinh', nganh: ['fnb'], nganhMoHinh: 'fnb', giaiDoan: ['Pre-seed', 'Seed'], doSau: 'lite', nhanNgan: '12 tháng, 4 tab',
    title: 'Mẫu mô hình tài chính cho chuỗi F&B',
    tenFile: 'mo-hinh-tai-chinh-chuoi-fnb',
    excerpt: 'Mô hình theo số điểm bán, số hoá đơn mỗi ngày và giá trị mỗi hoá đơn; tự tính doanh thu mỗi điểm và thời gian hoàn vốn một điểm bán.',
    bienSo: ['Số điểm bán và tốc độ mở mới', 'Số hoá đơn mỗi ngày mỗi điểm', 'Giá trị bình quân mỗi hoá đơn', 'Biên gộp sau giá vốn nguyên liệu', 'Vốn đầu tư mở một điểm bán'],
    baiLienQuan: 'mo-hinh-tai-chinh-cho-chuoi-fnb',
    congCu: [{ slug: 'tinh-runway', label: 'Tính runway' }, { slug: 'goi-bao-nhieu', label: 'Lập kế hoạch số vốn' }],
  },
  {
    slug: 'mo-hinh-tai-chinh-thuong-mai-dien-tu',
    kind: 'sinh', nhom: 'mo-hinh-tai-chinh', nganh: ['ecommerce'], nganhMoHinh: 'ecommerce', giaiDoan: ['Pre-seed', 'Seed'], doSau: 'lite', nhanNgan: '12 tháng, 4 tab',
    title: 'Mẫu mô hình tài chính cho thương mại điện tử',
    tenFile: 'mo-hinh-tai-chinh-thuong-mai-dien-tu',
    excerpt: 'Mô hình theo lưu lượng, tỷ lệ chuyển đổi, giá trị đơn và tỷ lệ mua lại; có sẵn dòng hoàn hàng mà nhiều bảng bỏ quên.',
    bienSo: ['Lưu lượng và tốc độ tăng', 'Tỷ lệ chuyển đổi', 'Giá trị bình quân mỗi đơn', 'Tỷ lệ mua lại của khách cũ', 'Tỷ lệ hoàn hàng'],
    baiLienQuan: 'mo-hinh-tai-chinh-cho-thuong-mai-dien-tu',
    congCu: [{ slug: 'kiem-tra-gia-dinh-kinh-te-don-vi', label: 'Kiểm tra kinh tế đơn vị' }],
  },
];

/**
 * Dashboard tương tác (10/2026): không có tệp mẫu tải lên, người dùng nhập số ngay trên
 * trang, in hoặc lưu PDF, tải Excel sinh từ số của họ. Cách chọn chỉ số và biểu đồ tham khảo CM Dashboard
 * Atlas của Christian Martinez; thiết kế, câu chữ và số ví dụ là của site.
 * Kế hoạch: ghi-chu/ke-hoach-dashboard-mau.md.
 */
const TEMPLATES_DASHBOARD = [
  {
    slug: 'dashboard-bao-cao-nha-dau-tu',
    kind: 'dashboard', nhom: 'dashboard', nganh: ['chung'], giaiDoan: ['Pre-seed', 'Seed'], doSau: 'lite', nhanNgan: 'Một trang, PDF và Excel',
    title: 'Dashboard báo cáo nhà đầu tư hằng tháng',
    excerpt: 'Nhập số chính mỗi tháng, nhận ngay một trang báo cáo gửi nhà đầu tư: doanh thu, tổng chi, tiền mặt, runway, chỉ số chính và bốn khối chữ. In, lưu PDF, tải Excel có công thức hoặc chép bản chữ để dán email, Zalo.',
    bienSo: ['Doanh thu, tổng chi và tiền mặt cuối tháng của vài tháng gần nhất', 'Số nhân sự', 'Một chỉ số chính nói rõ sản phẩm đang được dùng', 'Điều tốt, khó khăn, kế hoạch tháng tới và việc cần nhà đầu tư giúp'],
    baiLienQuan: '',
    congCu: [{ slug: 'tinh-runway', label: 'Tính runway' }, { slug: 'chi-so-tang-truong', label: 'Chỉ số tăng trưởng' }],
  },
  {
    slug: 'dashboard-dong-tien-13-tuan',
    kind: 'dashboard', nhom: 'dashboard', nganh: ['chung'], giaiDoan: ['Pre-seed', 'Seed'], doSau: 'lite', nhanNgan: '13 tuần, PDF và Excel',
    title: 'Dashboard runway và dòng tiền 13 tuần',
    excerpt: 'Khai từng khoản thu, chi một lần kèm cách lặp, xem số dư cuối mỗi tuần trong 13 tuần tới, tuần nào tiền thấp nhất, tuần nào chạm mức tối thiểu và runway sau 13 tuần. Tải Excel có công thức để sửa tiếp.',
    bienSo: ['Tiền mặt hiện có', 'Các khoản chi cố định và ngày trả (lương, bảo hiểm, thuê văn phòng)', 'Các khoản thu dự kiến và thời điểm thu', 'Khoản một lần sắp tới: thuế quý, thưởng Tết, giải ngân'],
    baiLienQuan: '',
    congCu: [{ slug: 'tinh-runway', label: 'Tính runway' }, { slug: 'goi-bao-nhieu', label: 'Lập kế hoạch số vốn' }],
  },
  {
    slug: 'dashboard-chuoi-fnb',
    kind: 'dashboard', nhom: 'dashboard', nganh: ['fnb'], giaiDoan: ['Pre-seed', 'Seed'], doSau: 'lite', nhanNgan: 'Từng điểm bán, PDF và Excel',
    title: 'Dashboard chuỗi F&B: hiệu quả từng điểm bán',
    excerpt: 'Nhập doanh thu và chi phí từng điểm bán trong tháng, xem điểm nào có lãi tại điểm, giá trị một hoá đơn, tỷ lệ giá vốn và tiền thuê trên doanh thu, và mở một điểm mới bao lâu hoàn vốn. Tải Excel có công thức.',
    bienSo: ['Doanh thu và số hoá đơn từng điểm trong tháng', 'Giá vốn nguyên liệu, tiền thuê, lương và chi khác tại từng điểm', 'Số vốn đã bỏ ra để mở từng điểm', 'Doanh thu tháng trước của từng điểm (nếu có)'],
    baiLienQuan: 'mo-hinh-tai-chinh-cho-chuoi-fnb',
    congCu: [{ slug: 'kiem-tra-gia-dinh-kinh-te-don-vi', label: 'Kiểm tra kinh tế đơn vị' }],
  },
  {
    slug: 'dashboard-thuong-mai-dien-tu',
    kind: 'dashboard', nhom: 'dashboard', nganh: ['ecommerce'], giaiDoan: ['Pre-seed', 'Seed'], doSau: 'lite', nhanNgan: 'Phễu, hoàn huỷ, PDF và Excel',
    title: 'Dashboard thương mại điện tử: phễu, hoàn huỷ và quảng cáo',
    excerpt: 'Nhập lượt truy cập, đơn đặt, đơn giao thành công, chi quảng cáo theo tháng. Dashboard tách giá trị đơn đặt với doanh thu thực về sau hoàn huỷ, rồi tính ROAS và chi phí có một khách trên doanh thu thực. Tải Excel có công thức.',
    bienSo: ['Lượt truy cập, đơn đặt và đơn giao thành công mỗi tháng', 'Giá trị đơn đặt mỗi tháng', 'Chi quảng cáo và số khách mới mỗi tháng'],
    baiLienQuan: 'mo-hinh-tai-chinh-cho-thuong-mai-dien-tu',
    congCu: [{ slug: 'kiem-tra-gia-dinh-kinh-te-don-vi', label: 'Kiểm tra kinh tế đơn vị' }, { slug: 'chi-so-tang-truong', label: 'Chỉ số tăng trưởng' }],
  },
  {
    slug: 'dashboard-cong-no-phai-thu',
    kind: 'dashboard', nhom: 'dashboard', nganh: ['chung'], giaiDoan: ['Pre-seed', 'Seed'], doSau: 'lite', nhanNgan: 'Bán cho doanh nghiệp, PDF và Excel',
    title: 'Dashboard công nợ phải thu cho startup bán cho doanh nghiệp',
    excerpt: 'Nhập các hoá đơn khách chưa trả, xem bao nhiêu tiền đang nằm ở khách, nợ quá hạn bao lâu theo từng nhóm tuổi nợ, phụ thuộc khách nào và bao nhiêu ngày mới thu được tiền (DSO). Tải Excel có công thức.',
    bienSo: ['Danh sách hoá đơn chưa thu đủ: khách, số tiền, đã thu, hạn thanh toán', 'Doanh thu 3 tháng gần nhất để tính DSO'],
    baiLienQuan: '',
    congCu: [{ slug: 'tinh-runway', label: 'Tính runway' }],
  },
];

/** Slug của mẫu sinh từ code — mẫu tải lên không được dùng trùng. */
export const SINH_SLUGS = [...TEMPLATES_SINH, ...TEMPLATES_DASHBOARD].map((t) => t.slug);

export const TEMPLATES = [
  ...TEMPLATES_DASHBOARD,
  ...TEMPLATES_SINH,
  ...REMOTE_TEMPLATES.filter((t) => t.status === 'PUBLISHED' && !SINH_SLUGS.includes(t.slug)),
];

export const templateBySlug = (slug) => TEMPLATES.find((t) => t.slug === slug) || null;

/** Bốn tab có trong mọi mẫu mô hình tài chính — dùng để mô tả trên trang mẫu. */
export const TABS_MO_HINH = [
  { ten: 'Hướng dẫn', moTa: 'Cách dùng mẫu và ba lỗi khiến quỹ mất niềm tin vào bảng số.' },
  { ten: 'Giả định', moTa: 'Tab duy nhất bạn nhập số. Mỗi giả định có ô ghi chú để ghi nguồn con số.' },
  { ten: 'Mô hình', moTa: '12 tháng, toàn bộ là công thức sống: doanh thu, chi phí, đốt ròng, tiền mặt, runway.' },
  { ten: 'Tóm tắt', moTa: 'Các con số quỹ hỏi trước tiên, tự tính từ tab Mô hình.' },
];
